import { useMemo } from 'react'

export const unassigned = (state, props) => {
  return useMemo(() => {
    return props.unassigned.filter(assignee => {
      return props.unassignedFilter(assignee, state.query, state.assigned)
    })
  }, [props.unassigned, state.query, state.assigned])
}
